import { render, staticRenderFns } from "./GoodsReturn.vue?vue&type=template&id=2ab3c24a&scoped=true"
import script from "./GoodsReturn.vue?vue&type=script&lang=js"
export * from "./GoodsReturn.vue?vue&type=script&lang=js"
import style0 from "./GoodsReturn.vue?vue&type=style&index=0&id=2ab3c24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3c24a",
  null
  
)

export default component.exports